/* Mobile Drawer Mega Slider — clones desktop mega images into drawer, places BELOW the menu list */
(function(){
  // --- CSS guard if file CSS not loaded in some themes
  (function ensureInlineCSS(){
    if(document.getElementById('drawerMegaCSS')) return;
    var st = document.createElement('style'); st.id='drawerMegaCSS';
    st.textContent = ".drawer-mega-wrap{margin:12px 0 6px}.drawer-mega-slider{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:2px 2px 6px}.drawer-mega-card{flex:0 0 60%;max-width:60%;background:var(--color-background,#fff);border-radius:12px;overflow:hidden;text-decoration:none;scroll-snap-align:start;box-shadow:0 1px 10px rgba(0,0,0,.06);color:inherit}@media (min-width:520px){.drawer-mega-card{flex-basis:44%;max-width:44%}}.drawer-mega-img{width:100%;height:120px;object-fit:cover;display:block}.drawer-mega-title{font-size:12.5px;line-height:1.35;padding:6px 8px 9px;text-align:center}";
    document.head.appendChild(st);
  })();

  var isMobile = function(){ return window.matchMedia('(max-width: 990px)').matches; };
  var textOf = function(el){ return (el && el.textContent || '').trim(); };

  function findDesktopSummaryByTitle(title){
    var sums = document.querySelectorAll('.header__inline-menu summary');
    for(var i=0;i<sums.length;i++){
      var span = sums[i].querySelector('span');
      if(textOf(span) === title) return sums[i];
    }
    return null;
  }

  function collectDesktopCards(title){
    var sum = findDesktopSummaryByTitle(title);
    if(!sum) return [];
    var content = sum.parentElement && sum.parentElement.querySelector('.mega-menu__content');
    if(!content) return [];
    // Prefer new .mega-card
    var cards = Array.prototype.slice.call(content.querySelectorAll('.mega-card')).map(function(card){
      var a = card.querySelector('a'), img = card.querySelector('img'), t = card.querySelector('.mega-card__title');
      return { href:(a && a.getAttribute('href'))||'#', src:(img && img.getAttribute('src')), alt:(img && img.getAttribute('alt'))||'', title:textOf(t) };
    }).filter(function(c){ return !!c.src; });
    if(cards.length) return cards;
    // Fallback old .mega_menu_img
    cards = Array.prototype.slice.call(content.querySelectorAll('.mega_menu_img')).map(function(li){
      var a = li.querySelector('a'), img = li.querySelector('img'), t = li.querySelector('.title');
      return { href:(a && a.getAttribute('href'))||'#', src:(img && img.getAttribute('src')), alt:(img && img.getAttribute('alt'))||'', title:textOf(t) };
    }).filter(function(c){ return !!c.src; });
    return cards;
  }

  function buildWrap(cards){
    var wrap = document.createElement('div'); wrap.className='drawer-mega-wrap';
    var slider = document.createElement('div'); slider.className='drawer-mega-slider';
    wrap.appendChild(slider);
    cards.forEach(function(c){
      var a = document.createElement('a'); a.className='drawer-mega-card'; a.href=c.href||'#';
      a.innerHTML = '<img class="drawer-mega-img" src="'+c.src+'" alt="'+(c.alt||c.title||'').replace(/"/g,'&quot;')+'">' + (c.title?('<div class="drawer-mega-title">'+c.title+'</div>'):'');
      slider.appendChild(a);
    });
    return wrap;
  }

  function insertAfter(ref, node){
    if(!ref) return;
    if(ref.nextSibling) ref.parentNode.insertBefore(node, ref.nextSibling);
    else ref.parentNode.appendChild(node);
  }

  function ensureBelowMenu(submenuEl, title){
    if(!submenuEl) return;
    var inner = submenuEl.querySelector('.menu-drawer__inner-submenu') || submenuEl;
    var list = inner.querySelector('.menu-drawer__menu');
    var wrap = inner.querySelector('.drawer-mega-wrap');

    if(!wrap){
      var cards = collectDesktopCards(title);
      if(!cards.length) return;
      wrap = buildWrap(cards);
    }

    if(list){
      // Move/insert wrap BELOW the menu list
      if(wrap.parentNode !== inner || wrap.previousElementSibling !== list){
        insertAfter(list, wrap);
      }
    }else{
      if(wrap.parentNode !== inner) inner.appendChild(wrap);
    }
  }

  function processAll(){
    if(!isMobile()) return; // only on mobile widths
    var details = document.querySelectorAll('.menu-drawer__navigation details[id^="Details-menu-drawer-menu-item-"]');
    Array.prototype.forEach.call(details, function(det){
      var sum = det.querySelector('summary');
      var title = textOf(sum);
      var submenu = det.querySelector('.menu-drawer__submenu');
      if(det.open) ensureBelowMenu(submenu, title);
      det.addEventListener('toggle', function(){ if(det.open) ensureBelowMenu(submenu, title); });
    });
  }

  function init(){
    var drawer = document.getElementById('menu-drawer') || document.body;
    processAll();
    // Observe dynamic mounts within drawer
    var mo = new MutationObserver(processAll);
    mo.observe(drawer, {childList:true, subtree:true});
    // Re-run on resize crossovers
    window.addEventListener('resize', function(){ if(isMobile()) processAll(); });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }

  // Re-initialize in Theme Editor when header section reloads
  document.addEventListener('shopify:section:load', init);
})();
